import styled from 'styled-components';
import { SolidButton } from '@avtkit/controls/Button';

export default styled(SolidButton).attrs({ elementType: 'submit', type: 'tertiary', variant: 'round' })``;
